export const iconFontAwesomeTransportationTruckArrowRight = (
	<i className="fa-solid fa-truck-arrow-right"></i>
);
